// The state of the three sub-branches of the Internal Review of one client
// (SEP-293 section 7). The header of the fact find, the vulnerability and the
// suitability pages reads it.

import { useQuery } from '@tanstack/react-query';
import type { InternalReviewBranches } from '@septima/contract';

import { api, staffErrorMessage } from '@/lib/api';

export const internalReviewKeys = {
    all: ['internal-review'] as const,
    client: (clientId: string) => ['internal-review', clientId] as const,
};

export function useInternalReview(clientId: string | undefined) {
    return useQuery({
        queryKey: internalReviewKeys.client(clientId ?? ''),
        enabled: Boolean(clientId),
        queryFn: async (): Promise<InternalReviewBranches> => {
            const res = await api.onboarding.internalReview({
                params: { clientId: clientId ?? '' },
            });
            if (res.status !== 200) throw new Error(staffErrorMessage(res.body, res.status));
            return res.body.branches;
        },
    });
}
